import React from "react";

import { decode } from "html-entities";
import PropTypes from "prop-types";

import Markdown from "./markdown/index";

import { useWebmessenger } from "../utils/webmessenger";

function Notification({ onClick }) {
    const { notification, closeNotification } = useWebmessenger();

    return (
        <div className="ek-chat__new">
            <div className="ek-chat__new--header">
                <span onClick={onClick} className="ek-chat__new--header--title">
                    {notification.title}
                </span>
                <button
                    type="button"
                    onClick={closeNotification}
                    className="ek-chat__new--header--button"
                >
                    <svg viewBox="0 0 24 24" version="1.1">
                        <g
                            stroke="none"
                            strokeWidth="1"
                            fill="none"
                            fillRule="evenodd"
                        >
                            <g
                                fill="#000000"
                                transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)"
                            >
                                <rect
                                    x="0"
                                    y="7"
                                    width="16"
                                    height="2"
                                    rx="1"
                                />
                                <rect
                                    transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000) "
                                    x="0"
                                    y="7"
                                    width="16"
                                    height="2"
                                    rx="1"
                                />
                            </g>
                        </g>
                    </svg>
                </button>
            </div>
            <div onClick={onClick}>
                <Markdown content={decode(notification.text)} notification />
            </div>
        </div>
    );
}

Notification.propTypes = {
    onClick: PropTypes.func,
};

Notification.defaultProps = {
    onClick: () => {},
};

export default Notification;
